import Vue from "vue";
import initialState from "./state";

export default {
    setPendingReceiptLogs(state, receiptLogs) {
        state.pendingReceiptLogs = receiptLogs;
    },
    setPendingReceiptLog(state, receiptLog) {
        const index = state.pendingReceiptLogs.findIndex(
            (log) => log.id === receiptLog.id,
        );
        if (index !== -1) {
            Vue.set(state.pendingReceiptLogs, index, receiptLog);
        }
    },
    addToPendingReceiptLogs(state, receiptLogs) {
        state.pendingReceiptLogs = [
            ...state.pendingReceiptLogs,
            ...receiptLogs,
        ];
    },
    setShowRequestDeliveryModal(state, show) {
        state.requestDeliveryModalVisible = show;
    },
    setRequestDeliveryType(state, type) {
        state.requestDeliveryType = type;
    },
    reset(state) {
        // Merge rather than replace so we don't lose observers
        // https://github.com/vuejs/vuex/issues/1118
        Object.assign(state, initialState());
    },
};
